import { NgModule } from '@angular/core';

import { AirQuoteResourceModule } from 'libraries/service/resources/airQuote/airQuoteResource.module';
import { CacheQuotedAvailabilityService } from './cache-quoted-availability.service';

@NgModule({
    imports: [],
    providers: [
        CacheQuotedAvailabilityService,
        AirQuoteResourceModule
    ],
})
export class CacheQuotedAvailabilityModule {}